import makeRpcCall from './jquery_rpc'
import LoadingPopup from '../LoadingPopup'

let loadingPopup = null

const createPopupLoadingMoire = () => {
    if (!loadingPopup)
        loadingPopup = new LoadingPopup().init("contentLoadingPopup")
}

const showPopupLoadingMoire = () => {
    if (loadingPopup)
        loadingPopup.show()
}

const hidePopupLoadingMoire = () => {
    if (loadingPopup)
        loadingPopup.hide()
}

function errorHandler(jqXHR, textStatus, errorThrown, showLoadingPopup, customErrorHandler) {
    if (showLoadingPopup)
        hidePopupLoadingMoire()

    if (customErrorHandler)
        return customErrorHandler(jqXHR, textStatus, errorThrown)

    return false
}

function successHandler(showLoadingPopup, data, customSuccessHandler) {

    const completeFunction = function() {
        if (showLoadingPopup)
            hidePopupLoadingMoire()

        if (customSuccessHandler)
            customSuccessHandler(data)
    }

    completeFunction()
}

export function loadPopupContentByRpcCall(rpcMethod, rpcParams, customSuccessHandler, showLoadingPopup, customErrorHandler) {
    hidePopupLoadingMoire()

    if (showLoadingPopup) {
        createPopupLoadingMoire()
        loadingPopup.setOnEscapeCallback(function() {
            if (loadPopupRequestObject)
                loadPopupRequestObject.abort()
        })
        loadingPopup.show()
    }

    let loadPopupRequestObject = makeRpcCall(
        rpcMethod,
        rpcParams,
        (data) => successHandler(showLoadingPopup, data, customSuccessHandler),
        (jqXHR, textStatus, errorThrown) => errorHandler(jqXHR, textStatus, errorThrown, showLoadingPopup, customErrorHandler))
}



// WEBPACK FOOTER //
// ./web/js/util/PopupLoadingUtils.js